import { render, staticRenderFns } from "./thirdSamAdd.vue?vue&type=template&id=00485848&scoped=true"
import script from "./thirdSamAdd.vue?vue&type=script&lang=js"
export * from "./thirdSamAdd.vue?vue&type=script&lang=js"
import style0 from "./thirdSamAdd.vue?vue&type=style&index=0&id=00485848&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00485848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00485848')) {
      api.createRecord('00485848', component.options)
    } else {
      api.reload('00485848', component.options)
    }
    module.hot.accept("./thirdSamAdd.vue?vue&type=template&id=00485848&scoped=true", function () {
      api.rerender('00485848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/thirdSam/thirdSamAdd.vue"
export default component.exports